import { deleteCookie, setCookie, getCookie } from 'cookies-next'
import { TOKEN_COOKIE, COOKIE_EXPIRE_TIME, INVITE_CODE_STORAGE } from './constants'

export function checkLogin() {
  return !!getToken()
}

export function getToken() {
  return getCookie(TOKEN_COOKIE)
}

export function deleteToken() {
  deleteCookie(TOKEN_COOKIE)
  localStorage.removeItem(TOKEN_COOKIE)
}

export function setToken(value = '') {
  setCookie(TOKEN_COOKIE, value, { maxAge: COOKIE_EXPIRE_TIME })
  localStorage.setItem(TOKEN_COOKIE, value)
}

export function clearInviteCode() {
  localStorage.removeItem(INVITE_CODE_STORAGE)
}
